import type { Item, WorldData } from '../types/world'

/** Prefijos con los que items.csv nombra a los ítems que enseñan un poder. */
const SKILL_PREFIX = /^(scroll|orb|parchment|book|pergamino|orbe|libro)\s+(of|de(l)?)\s+/i

/** Secciones de items.csv que contienen pergaminos de habilidad (Season 6: sección 15). */
const SCROLL_SECTIONS = new Set([15])

/**
 * Nombre del poder que enseña un ítem, o undefined si no es un ítem de habilidad.
 * Se basa solo en el nombre y la sección del propio ítem, nunca en suposiciones externas.
 */
export function skillNameOf(item: Item): string | undefined {
  const m = SKILL_PREFIX.exec(item.name)
  if (m) return item.name.slice(m[0].length).trim()
  if (item.section !== undefined && SCROLL_SECTIONS.has(item.section)) return item.name.trim()
  return undefined
}

export function skillKindOf(item: Item): string {
  const p = /^(\w+)/.exec(item.name)?.[1]?.toLowerCase()
  if (p === 'orb' || p === 'orbe') return 'Orbe de habilidad'
  if (p === 'parchment') return 'Pergamino de comando'
  if (p === 'book' || p === 'libro') return 'Libro de habilidad'
  return 'Pergamino de habilidad'
}

export function isSkillItem(w: WorldData, id: string): boolean {
  const it = w.items.get(w.variants.get(id)?.itemId ?? id)
  return !!it && skillNameOf(it) !== undefined
}
